import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [devNote, setDevNote] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(true);
      setDevNote(data.email_delivery === "dev_not_configured");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className="min-h-[calc(100vh-72px)] flex items-center justify-center py-16 px-5" data-testid="forgot-page">
      <div className="w-full max-w-md bg-white rounded-3xl border border-[#E3E8E8] shadow-soft p-8">
        <Link to="/"><Logo /></Link>
        <h1 className="font-display font-extrabold text-3xl text-[#0B1733] mt-6">Reset password</h1>
        {sent ? (
          <div className="mt-5 text-sm text-[#4A5568]" data-testid="forgot-sent">
            <p>If an account exists for <b>{email}</b>, a reset link has been generated.</p>
            {devNote && <p className="mt-3 p-3 rounded-lg bg-[#E8F5F1] text-[#0B1733]">Development status: outgoing email is not configured, so the reset link was written to the server log instead of being emailed.</p>}
            <Link to="/login" className="inline-block mt-5 text-[#007F83] font-medium hover:underline">Back to login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email-input" className="mt-1.5 h-11" />
            </div>
            <Button type="submit" data-testid="forgot-submit-btn" className="w-full h-11 rounded-full bg-[#007F83] hover:bg-[#006B70] text-white">Send reset link</Button>
          </form>
        )}
      </div>
    </div>
  );
}
